export const iconFontAwesomeHumanitarianPersonThroughWindow = (
	<i className="fa-solid fa-person-through-window"></i>
);
